import { render, staticRenderFns } from "./b2b-data-table-envios.vue?vue&type=template&id=d22ea878&scoped=true"
import script from "./b2b-data-table-envios.vue?vue&type=script&lang=js"
export * from "./b2b-data-table-envios.vue?vue&type=script&lang=js"
import style0 from "./b2b-data-table-envios.vue?vue&type=style&index=0&id=d22ea878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22ea878",
  null
  
)

export default component.exports